import { render, staticRenderFns } from "./InscriptionRegistre.vue?vue&type=template&id=d054c776"
import script from "./InscriptionRegistre.vue?vue&type=script&lang=js"
export * from "./InscriptionRegistre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports